<template>
  <div class="repair-status-item">
    <RepairStatusItemHeader :result="result" />
    <div class="repair-status-item__container">
      <RepairStatusItemProgress :result="result" />
      <RepairStatusItemFooter :result="result" />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import RepairStatusItemHeader from '@components/Cabinet/Repair/RepairStatus/RepairStatusItem/RepairStatusItemHeader.vue';
import RepairStatusItemProgress from '@components/Cabinet/Repair/RepairStatus/RepairStatusItem/RepairStatusItemProgress.vue';
import RepairStatusItemFooter from '@components/Cabinet/Repair/RepairStatus/RepairStatusItem/RepairStatusItemFooter.vue';

const { result } = defineProps(['result']);
</script>

<script>
export default {
  name: 'RepairStatusItem',
};
</script>

<style lang="scss" scoped>
.repair-status-item {
  display: grid;
  grid-row-gap: 32px;
  border: 1px solid #cacece;
  &__container {
    display: grid;
    grid-row-gap: 32px;
    padding: 0 16px 16px;
    @include point-md {
      padding: 0 16px 24px 40px;
    }
    @include point-lg {
      padding: 0 16px 16px 41px;
    }
  }
}
</style>
